import { Family } from '../types/family';
import { BonusTx, OccurrenceState } from '../types/activity';
import { isDoneStatus } from './progress';
import { hasLessonOn, isGivenAway } from './today';
import { opportunityOn } from './rewards';

export interface BonusLine {
  reason: string;
  amount: number;
}

// Bonus, ki izhaja iz današnjih zapisov (dodatne minute, prostovoljna vadba, urejena soba).
// Izračuna se iz stanja, zato ponovno obkljukanje ali shranjevanje ne podvoji točk.
export function derivedBonusToday(
  family: Family,
  memberId: string,
  occ: Record<string, OccurrenceState>,
  minutesOf: (templateId: string) => number,
  sportGoalMetBefore = false
): BonusLine[] {
  const r = family.rules;
  const lesson = hasLessonOn(family, memberId);
  const lines: BonusLine[] = [];
  family.templates
    .filter((t) => t.assigneeIds.includes(memberId) && family.modules[t.module])
    .forEach((t) => {
      const o = occ[t.id];
      const done = isDoneStatus(o?.status) && !isGivenAway(o, memberId);
      if (t.extraMinutesBonus && t.targetMinutes && opportunityOn(r, 'extraMinutes')) {
        const min = minutesOf(t.id);
        let extra = 0;
        if (t.planKey === 'instrument' && lesson) {
          if (min >= 30 || done) {
            lines.push({ reason: `${t.title}: prostovoljno na dan pouka`, amount: r.lessonDayBonus });
            extra = min - 30;
          }
        } else if (done) {
          extra = min - t.targetMinutes;
        }
        if (extra >= r.extraMinutesStep) {
          const amount = Math.min(r.extraDailyMax, Math.floor(extra / r.extraMinutesStep) * r.extraMinutesBonus);
          lines.push({ reason: `${t.title}: +${extra} min nad ciljem`, amount });
        }
      }
      // Dodatna vadba nad tedenskim ciljem (začetno +3); ista izvedba ne šteje v osnovni napredek.
      if (t.planKey === 'sport' && done && sportGoalMetBefore) {
        lines.push({ reason: 'Dodatna športna vadba nad tedenskim ciljem', amount: 3 });
      }
      if (t.group === 'hisa' && t.valueType === 'bonus' && done && opportunityOn(r, 'roomDay')) {
        lines.push({ reason: t.title, amount: t.baseValue ?? r.roomBonus });
      }
    });
  return lines;
}

export function ledgerSum(ledger: BonusTx[], familyId: string, memberId: string): number {
  return ledger.filter((t) => t.familyId === familyId && t.memberId === memberId).reduce((s, t) => s + t.amount, 0);
}
